import type { ReactElement } from 'react';
import {
  Package,
  Stack,
  Warehouse,
  ShieldCheck,
  SealCheck,
  MapPin,
  Check,
  Question
} from '@nexvia-logistics/ui/icons';
import type { IconProps } from '@nexvia-logistics/ui/icons';

/**
 * Real icon set (NEX-1151 design-system migration, 2026-10-14). Every export below used to be a
 * hand-drawn placeholder SVG — now a thin re-export of the real `@nexvia-logistics/ui/icons`
 * glyph under the SAME name, so no call site in this app needs to change. `IconProps` (size/
 * title/standard SVG props, colour via currentColor) is a superset of what every caller already
 * passes, confirmed by reading `@nexvia-logistics/ui/icons`' own `IconBase.d.ts` before this swap.
 *
 * One name is a judgment call, not a confirmed 1:1 label match — flagged here, not guessed
 * silently: the real icon set has no icon literally named "lockers".
 *   - LockersIcon -> Warehouse: closest real icon for a storage depot (`depositos` nav item);
 *     `Archive`/`Buildings` were the other candidates, picked `Warehouse` as the most literal
 *     storage-specific glyph. [ASSUMED] Cheap to swap later if a visual check says otherwise —
 *     every caller only ever imports the name on the left.
 *
 * NEX-1164 (2026-10-15): `MenuIcon`, `LogoutIcon`, `BellIcon` and `SidebarIcon` left with the
 * hand-rolled shell — the package's `AppShell` draws its own hamburger, bell, rail toggle and
 * sign-out glyphs. `NAV_ICON_BY_ID` is what `AppLayout.tsx` turns into each real `NavItem.icon`.
 */
export const PackageIcon = Package;
export const StackIcon = Stack;
export const LockersIcon = Warehouse;
export const ShieldCheckIcon = ShieldCheck;
export const SealCheckIcon = SealCheck;
export const MapPinIcon = MapPin;
export const CheckIcon = Check;
export const QuestionIcon = Question;

export type { IconProps };
export type { ReactElement };

export const NAV_ICON_BY_ID: Record<string, (props: IconProps) => ReactElement> = {
  solicitudes: PackageIcon,
  cotizaciones: StackIcon,
  depositos: LockersIcon,
  servicios: ShieldCheckIcon,
  empresa: SealCheckIcon
};
